import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const AdSenseAd = ({
  adSlot,
  adFormat = "auto",
  style = {},
  fullWidthResponsive = true,
}) => {
  const adRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Don't show ads on admin pages
    const isAdminPage = location.pathname.startsWith("/admin");

    if (!isAdminPage && window.adsbygoogle && adRef.current) {
      try {
        // Push the ad to AdSense
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error("AdSense error:", error);
      }
    }
  }, [location.pathname]);

  // Don't render ads on admin pages
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  const defaultStyle = {
    display: "block",
    minHeight: "200px",
    width: "100%",
    ...style,
  };

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={defaultStyle}
      data-ad-client="ca-pub-3108752809294808"
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      data-full-width-responsive={fullWidthResponsive}
    />
  );
};

export default AdSenseAd;
